import BaseService from './BaseService';
import apiClient from '../plugins/axios';

class RoleService extends BaseService {
  constructor() {
    super('role');
  }

  async getAll() {
    try {
      const response = await apiClient.get('/roles');
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createRole(roleData) {
    try {
      const response = await apiClient.post('/role', roleData);
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getRoleById(id) {
    try {
      const response = await apiClient.get(`/role/${id}`);
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async updateRole(id, roleData) {
    try {
      const response = await apiClient.put(`/role/${id}`, roleData);
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deleteRole(id) {
    try {
      const response = await apiClient.delete(`/role/${id}`);
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // permissions: string[] (permission id'leri)
  async assignPermissionsToRole(roleId, permissions) {
    try {
      const response = await apiClient.post(`/role/${roleId}/permission`, { permissions });
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new RoleService();
